import { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'Shared/util/custom-hooks';
import useUserContext from 'Contexts/user-context';
import makeComponentTrashable from 'trashable-react';
import { orgUsers } from 'Shared/util/web-api';
import Page from 'Shared/components/page/page';
import Button from 'Shared/components/button';
import { UserEditStatus } from './user-administration-utils';
import UserSettingsCard from './user-settings-card';
import UserEditView from './user-edit/user-edit-view';
import styles from './manage-users-page.css';


const ManageUsersPage = ({
  registerPromise,
}) => {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState();
  const [userEditStatus, setUserEditStatus] = useState(UserEditStatus.NONE);

  const {
    user,
  } = useUserContext();

  const t = useTranslation(x => x.manage_users);

  const fetchUsers = useCallback((ugId) => {
    registerPromise(orgUsers(ugId))
      .then((result) => setUsers(result))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const activeCompanyId = user?.activeCompany?.id;
    if (activeCompanyId) {
      setLoading(true);
      fetchUsers(activeCompanyId);
    }
  }, [user?.activeCompany?.id]);

  const handleShowAddUser = () => setUserEditStatus(UserEditStatus.NEW);

  const handleShowEditUser = (pickedUser) => {
    const newEditStatus = (user.id === pickedUser.id ? UserEditStatus.EDIT_SELF : UserEditStatus.EDIT_OTHER);
    setSelectedUser(pickedUser);
    setUserEditStatus(newEditStatus);
  };

  const handleUserEditHide = (action) => {
    setUserEditStatus(UserEditStatus.NONE);
    if (action === 'update') {
      fetchUsers(user.activeCompany.id);
    }
  };

  return (
    <Page
      narrowWidth
      title={t.manage_users}
      loading={loading}
    >
      <Button
        buttonType="action-primary"
        text={t.add_user}
        onClick={handleShowAddUser}
        className={styles.addUser}
      />
      {users.map((u) => (
        <UserSettingsCard
          key={u.id}
          user={u}
          activeUserId={user.id}
          activeUgId={user.activeCompany.id}
          onClick={handleShowEditUser}
          className={styles.settingsCard}
        />
      ))}
      <UserEditView
        selectedUser={selectedUser}
        organisation={user.activeCompany}
        status={userEditStatus}
        onHide={handleUserEditHide}
      />
    </Page>
  );
};

ManageUsersPage.propTypes = {
  registerPromise: PropTypes.func.isRequired,
};

export default makeComponentTrashable(ManageUsersPage);
